import React from 'react';
import * as GlobalVariables from '../config/GlobalVariableContext';
import {
  ButtonOutline,
  ButtonSolid,
  Row,
  ScreenContainer,
  StarRating,
  withTheme,
} from '@draftbit/ui';
import { Modal, StyleSheet, Text, View } from 'react-native';

const ReflectPresenceScreen = props => {
  const Constants = GlobalVariables.useValues();
  const Variables = Constants;
  const setGlobalVariableValue = GlobalVariables.useSetValue();

  const { theme } = props;
  const { navigation } = props;

  const [starRatingValue, setStarRatingValue] = React.useState(0);

  return (
    <ScreenContainer
      scrollable={false}
      hasSafeArea={true}
      hasTopSafeArea={true}
    >
      <View>
        <Text style={[styles.Text37c426fd, { color: theme.colors.strong }]}>
          {'How was your time with your children yesterday?\n'}
        </Text>
      </View>

      <View style={styles.View6f3bcb1e}>
        <Text style={[styles.Textc2499e1c, { color: theme.colors.strong }]}>
          {'Presence'}
        </Text>

        <Modal
          visible={Constants['Visible']}
          animationType={'slide'}
          presentationStyle={'fullScreen'}
        >
          <Text style={[styles.Texta3db204c, { color: theme.colors.strong }]}>
            {
              '\n\nWas your child able to get your undivided presence and attention? Or were they unable to do so because of distractions, multitasking and operating in an autopilot mode?'
            }
          </Text>
          {/* Close */}
          <ButtonOutline
            onPress={() => {
              try {
                setGlobalVariableValue({
                  key: 'Visible',
                  value: false,
                });
              } catch (err) {
                console.error(err);
              }
            }}
            style={styles.ButtonOutline3975593b}
            title={'Close'}
          />
        </Modal>
        {/* Presence Rating */}
        <StarRating
          onPress={newPresenceRatingValue => {
            try {
              const starRatingValueF = setGlobalVariableValue({
                key: 'presence',
                value: newPresenceRatingValue,
              });
            } catch (err) {
              console.error(err);
            }
          }}
          style={styles.StarRating02f8ec45}
          activeColor={theme.colors.primary}
          starSize={32}
          isEditable={true}
          maxStars={5}
          inactiveColor={theme.colors.light}
          defaultValue={1}
        />
      </View>

      <View style={styles.View2c4fedbd}>
        <Row alignItems={'flex-start'} justifyContent={'space-around'}>
          <ButtonSolid
            onPress={() => {
              try {
                setGlobalVariableValue({
                  key: 'Visible',
                  value: true,
                });
              } catch (err) {
                console.error(err);
              }
            }}
            style={[
              styles.ButtonSolidba5cb9c8,
              { backgroundColor: theme.colors.primary },
            ]}
            title={'Info'}
          />
          <ButtonSolid
            onPress={() => {
              try {
                navigation.navigate('ReflectEquanimityScreen');
              } catch (err) {
                console.error(err);
              }
            }}
            style={[
              styles.ButtonSolid9f0cb554,
              { backgroundColor: theme.colors.primary },
            ]}
            title={'Next'}
          />
        </Row>
      </View>
    </ScreenContainer>
  );
};

const styles = StyleSheet.create({
  ButtonOutline3975593b: {
    backgroundColor: 'transparent',
    borderRadius: 8,
    borderWidth: 1,
    fontFamily: 'System',
    fontWeight: '700',
    marginTop: 20,
    textAlign: 'center',
  },
  ButtonSolid9f0cb554: {
    borderRadius: 8,
    fontFamily: 'System',
    fontWeight: '700',
    marginLeft: 20,
    textAlign: 'center',
  },
  ButtonSolidba5cb9c8: {
    borderRadius: 8,
    fontFamily: 'System',
    fontWeight: '700',
    textAlign: 'center',
  },
  StarRating02f8ec45: {
    marginTop: 20,
  },
  Text37c426fd: {
    fontFamily: 'Roboto_400Regular',
    fontSize: 28,
    marginTop: 40,
    textAlign: 'center',
  },
  Text8189c9ab: {
    marginTop: 20,
    textAlign: 'center',
  },
  Texta3db204c: {
    marginTop: 200,
    textAlign: 'center',
  },
  Textc2499e1c: {
    fontSize: 18,
    textAlign: 'center',
  },
  View2c4fedbd: {
    alignItems: 'center',
    marginTop: 20,
  },
  View6f3bcb1e: {
    alignItems: 'center',
    marginTop: 150,
  },
});

export default withTheme(ReflectPresenceScreen);
